import { RouteComponentProps } from 'react-router-dom';
import { useFormik } from 'formik';
import { useSelector } from 'react-redux';

import { Logo } from 'components/Logo';
import { Input } from 'components/Input';
import { Button } from 'components/Button';

import { login as loginActions } from 'modules/user/actions';

import { LoginRequestBody, Store } from 'types';
import { LoginFormValidation, useAction } from 'utils';

import styles from './styles.module.scss';

export const Login: React.FC<RouteComponentProps> = () => {
  const { loading, error } = useSelector((store: Store) => store.user);
  const login = useAction(loginActions.request);
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormik<LoginRequestBody>({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: LoginFormValidation,
    onSubmit: (values) => {
      login(values);
    },
  });

  return (
    <div className={styles.container}>
      <div>
        <Logo compact />
        {error && <p>{error}</p>}
        <Input
          type="email"
          placeholder="login"
          name="email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.email ? errors.email : undefined}
        />
        <Input
          type="password"
          placeholder="password"
          name="password"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.password ? errors.password : undefined}
        />
        <Button title="Log in" loading={loading} onClick={handleSubmit} />
      </div>
    </div>
  );
};
